// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

function requestCheckingAccountsRequest() {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_REQUEST
    };
}

function requestCheckingAccountsSuccess(response, originCountry) {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_SUCCESS,
        payload: {
            data: response,
            originCountry
        }
    };
}

function requestCheckingAccountsFailure(response) {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_FAILURE,
        payload: {
            data: response
        }
    };
}

function requestCheckingAccounts() {
    return function(dispatch, getState) {
        const originCountry = getState().profile.get('originCountry');
        dispatch(requestCheckingAccountsRequest());
        return APIGet(dispatch, apiURLBuilder.getURL('brokerCheckingAccounts'))
            .then(function(response) {
                dispatch(requestCheckingAccountsSuccess(response, originCountry));
            }, function(response) {
                dispatch(requestCheckingAccountsFailure(response));
            }
        );
    };
}

module.exports = {
    requestCheckingAccounts
}
